import script from "./ServiceAgreementModalForEvent.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceAgreementModalForEvent.vue?vue&type=script&setup=true&lang=js"

import "./ServiceAgreementModalForEvent.vue?vue&type=style&index=0&id=3661299f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3661299f"]])

export default __exports__